import React, { Component } from "react";
import { OrderDetailsWrapper, OrderStatusWrapper } from "./OrderDetails.style";
import { Modal, Spin, Tag, Tooltip } from "antd";
import BarcodeScanner from "../BarcodeScanner/BarcodeScanner";

export class OrderDetails extends Component {
  state = {
    changeBoxModal: false,
    showScannerScreen: false,
  };

  boxChangeOkClick = () => {
    this.props.updateBox(true);

    setTimeout(this.setState({ changeBoxModal: false }), 2000);
  };

  render() {
    return (
      <Spin spinning={this.props.isLoading}>
        {this.props.tagText && (
          <OrderStatusWrapper>
            <div
              className={
                this.props.tagColor === "red"
                  ? "previousDayOrder"
                  : this.props.tagColor === "yellow"
                  ? "todayOrder"
                  : "hyperlocalOrder"
              }
            >
              <span>{this.props.tagText}</span>
            </div>
          </OrderStatusWrapper>
        )}
        <OrderDetailsWrapper>
          <div className="orderIdWrapper">
            <label>Order Id :</label>
            <p>{this.props.orderId}</p>
            {/* <span
              className={
                this.props.tagColor === "red"
                  ? "danger"
                  : this.props.tagColor === "yellow"
                  ? "cool"
                  : "success"
              }
            >
              {this.props.tagText}
            </span> */}

            {this.props.boxId && (
              <div style={{ flexGrow: 1 }}>
                <Tag
                  color="volcano"
                  className="boxSection"
                  onClick={() => this.setState({ changeBoxModal: true })}
                >
                  BOX#{this.props.boxId}
                </Tag>
                {/* <Tag color={this.props.tagColor} className="boxSection">
                  {this.props.tagText}
                </Tag> */}
              </div>
            )}
          </div>

          <label>Customer Name :</label>
          <p>{this.props.customerName}</p>

          <label>Invoice Date :</label>
          <p>{this.props.invoiceDate}</p>

          <label>Payment Type :</label>
          <p>{this.props.paymentType}</p>

          <label>Order Value :</label>
          <p>₹{this.props.orderValue}</p>

          {this.props.pickerName && <label>Picker Name :</label>}
          {this.props.pickerName && <p>{this.props.pickerName}</p>}

          <Modal
            title="Change the box"
            visible={this.state.changeBoxModal}
            // centered
            onOk={() =>
              this.setState({ changeBoxModal: false }, () =>
                this.props.updateBox(true)
              )
            }
            onCancel={() => this.setState({ changeBoxModal: false })}
          />
        </OrderDetailsWrapper>
      </Spin>
    );
  }
}

export default OrderDetails;
